import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box>
      <Typography variant="h3" color={colors.secondary[400]} fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="h6" color={colors.secondary[300]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
